module.exports = __webpack_public_path__ + "img/泗水滩底贡园1.ffce71fe.png";